"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPricingSummary = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Button_1 = require("../button/Button");
const theme_1 = __importDefault(require("../styles/theme"));
const helpers_1 = require("../../../entities/pricing/helpers");
const helpers_2 = require("../../../view/pages/tasks/pricing/helpers");
const Wrapper = styled_1.default.div `
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
const IconTextWrapper = styled_1.default.div `
	display: flex;
	align-items: center;
`;
const Summary = styled_1.default.div `
	${theme_1.default.typography.c1};
`;
const SummarySubText = styled_1.default.div `
	${theme_1.default.typography.c2};
`;
const Icon = styled_1.default.div `
	color: ${theme_1.default.colours.neutral.white};
	background-color: ${theme_1.default.colours.primary.misc};
	width: 40px;
	height: 40px;
	text-align: center;
	line-height: 40px;
	font-weight: 500;
	border-radius: 50%;
	margin-right: ${theme_1.default.layout.spacing.small};
`;
const ButtonWrapper = styled_1.default.div `
	border-left: 1px solid ${theme_1.default.colours.neutral.light};
	padding-left: ${theme_1.default.layout.spacing.small};
`;
const SmartPricingSummary = ({ minPrice, currency, onEditClicked, }) => {
    // Floydian 10000 = £1 so this should never happen genuinely, this guards against state updating incorrectly
    const summaryMinPrice = minPrice < 10000 ? minPrice : (0, helpers_2.fromFloyd)(minPrice);
    return (react_1.default.createElement(Wrapper, { "data-testId": "smart-pricing-summary" },
        react_1.default.createElement(IconTextWrapper, null,
            react_1.default.createElement(Icon, null, (0, helpers_1.getCurrencySymbol)(currency)),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Summary, null, "Smart pricing"),
                react_1.default.createElement(SummarySubText, null, "1 year availability"),
                react_1.default.createElement(SummarySubText, null, `Min price: ${(0, helpers_1.getCurrencySymbol)(currency)}${summaryMinPrice}`))),
        react_1.default.createElement(ButtonWrapper, null,
            react_1.default.createElement(Button_1.Button, { onClick: onEditClicked, buttonType: Button_1.PresetThemes.Neutral }, "Edit"))));
};
exports.SmartPricingSummary = SmartPricingSummary;
//# sourceMappingURL=SmartPricingSummary.js.map